module.exports = __webpack_public_path__ + "img/CRE_icon_warning-exclamation.b880ab6d382925325890e076391e5111.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CRE_icon_warning-exclamation.svg
// module id = 802
// module chunks = 0